// Mapping of figma variables to json object (2025-12-19)

export const colours = {
    'swatch': {
        'black'           : '000000',
        'neutral-00'      : '#ffffffff',
        'neutral-100'     : '#e9e9e9ff',
        'neutral-200'     : '#d4d4d4ff',
        'neutral-25'      : '#fafafaff',
        'neutral-300'     : '#bebebeff',
        'neutral-400'     : '#a8a8a8ff',
        'neutral-50'      : '#f4f4f4ff',
        'neutral-500'     : '#939393ff',
        'neutral-600'     : '#7d7d7dff',
        'neutral-700'     : '#686868ff',
        'neutral-800'     : '#525252ff',
        'neutral-900'     : '#3c3c3cff',
        'neutral-950'     : '#191919ff',
        'pastel-blue'     : '#f0f3fbff',
        'pastel-green'    : '#e5eddfff',
        'pastel-orange'   : '#fff4e1ff',
        'pastel-red'      : '#fcf0f0ff',
        'pastel-yellow'   : '#fdf8dcff',
        'red-100'         : '#fdeceaff',
        'red-400'         : '#f4776aff',
        'red-500'         : '#ec221fff',
        'red-600'         : '#c00f0cff',
        'secondary-blue'  : '#cfe3ebff',
        'secondary-yellow': '#ffae00ff',
        'tint-dark-10'    : '#0000001a',
        'tint-dark-20'    : '#00000033',
        'tint-dark-30'    : '#0000004d',
        'tint-dark-40'    : '#00000066',
        'tint-dark-50'    : '#00000080',
        'tint-dark-60'    : '#00000099',
        'tint-dark-70'    : '#000000b2',
        'tint-dark-80'    : '#000000cc',
        'tint-dark-90'    : '#000000e5',
        'tint-light-0'    : '#ffffff00',
        'tint-light-10'   : '#ffffff1a',
        'tint-light-20'   : '#ffffff33',
        'tint-light-30'   : '#ffffff4d',
        'tint-light-40'   : '#ffffff66',
        'tint-light-50'   : '#ffffff80',
        'tint-light-60'   : '#ffffff99',
        'tint-light-70'   : '#ffffffb2',
        'tint-light-80'   : '#ffffffcc',
        'tint-light-90'   : '#ffffffe5',
        'transparent'     : '#ffffff00',
        'white'           : '#ffffff'
    },
    'semantic': {
        'border-active'                 : 'var(--neutral-950)',
        'border-danger'                 : 'var(--red-400)',
        'border-danger-hover'           : 'var(--red-500)',
        'border-default'                : 'var(--tint-dark-20)',
        'button-primary-surface'        : 'var(--neutral-800)',
        'button-primary-surface-hover'  : 'var(--neutral-900)',
        'button-secondary-surface'      : 'var(--neutral-100)',
        'button-secondary-surface-hover': 'var(--neutral-900)',
        'button-tint-surface'           : 'var(--neutral-00)',
        'button-tint-surface-hover'     : 'var(--tint-light-50)',
        'control-surface-hover'         : 'var(--neutral-800)',
        'control-surface-selected'      : 'var(--neutral-900)',
        'control-surface-unselected'    : 'var(--tint-light-0)',
        'icon-danger-default'           : 'var(--red-600)',
        'icon-danger-secondary'         : 'var(--red-500)',
        'icon-danger-tertiary'          : 'var(--red-400)',
        'icon-default-invert'           : 'var(--neutral-00)',
        'icon-default-primary'          : 'var(--neutral-950)',
        'icon-default-secondary'        : 'var(--neutral-700)',
        'icon-default-tertiary'         : 'var(--neutral-500)',
        'surface-canvas'                : 'var(--neutral-00)',
        'surface-danger'                : 'var(--red-100)',
        'surface-emphasis'              : 'var(--secondary-yellow)',
        'surface-panel-blue'            : 'var(--pastel-blue)',
        'surface-panel-green'           : 'var(--pastel-green)',
        'surface-panel-neutral'         : 'var(--neutral-50)',
        'surface-panel-orange'          : 'var(--pastel-orange)',
        'surface-panel-red'             : 'var(--pastel-red)',
        'surface-panel-yellow'          : 'var(--pastel-yellow)',
        'surface-raised'                : 'var(--neutral-00)',
        'surface-raised-hover'          : 'var(--neutral-50)',
        'surface-strong'                : 'var(--secondary-blue)',
        'text-danger-default'           : 'var(--red-600)',
        'text-danger-secondary'         : 'var(--red-500)',
        'text-danger-tertiary'          : 'var(--red-400)',
        'text-default-invert'           : 'var(--neutral-00)',
        'text-default-primary'          : 'var(--neutral-950)',
        'text-default-secondary'        : 'var(--neutral-700)'
    }
};
